import assign from 'lodash/assign';
import reduce from 'lodash/reduce';

const actions = [
  // user
  'UPDATE_USER_INFO', // done
  'UPDATE_APP', // ignore

  // search
  'ADD_RECENT_SEARCH', // done

  // address
  'SET_ADDRESS', // done
  'ADDRESS_DETAILS', // done

  // filters
  'UPDATE_FILTER', // done
];

const dispatchConstants = reduce(
  actions,
  (accumulator, value) => {
    accumulator[value] = value;
    return accumulator;
  },
  { ADDRESS_AUTO_COMPLETE: 'ADDRESS_AUTO_COMPLETE', ADDRESS_STATUS_FAILURE: 'FAILURE', UNIT_NUMBER_LENGTH_LIMIT: 20 },
);

const constants = assign({}, dispatchConstants);

export default constants;
